export const TYPE_VOUCHER = 0;
export const TYPE_GIFT = 3;